module.exports = __webpack_public_path__ + "img/homeMaskMax.59777aa7.png";